import TomSelect from "tom-select"

export default (el, { expression }, { Alpine, evaluate, cleanup }) => {

    const data = evaluate(expression)

    let instance = null

    const init = () => {
        instance = new TomSelect(el, {
            plugins: ['remove_button'],
            valueField: 'id',
            labelField: 'label',
            searchField: 'label',
            options: data.options,
            placeholder: undefined,
            render: {
                option: (data, escape) => `<div class='flex items-center'>
                    <div><span class='block font-medium'>${escape(data.label)}</span>
                </div>`,
                item: (data, escape) => `<div>
                    <span class='block font-medium'>${escape(data.label)}</span>
                </div>`
            }
        })
    }

    init()

    Alpine.magic('refreshTomselect', (el, { Alpine }) => {
        instance.destroy()
        init()
    })

    cleanup(() => {
        instance.destroy()
    })
}